// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2xtKT","label":"Section_label__KBVk8","contentWrap":"Section_contentWrap__1gmMY","footer":"Section_footer__mDyI6","footerInner":"Section_footerInner__2b7pH"};